<template>
  <router-view></router-view>
</template>

<script>
import { LogActiveUser } from "../../classes";
import Vue from "vue";
export default {
  data(){
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
    }
  },
  computed: {
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
  },
  created(){
    LogActiveUser.createLogActiveUser(this.marketId)
    if(!this.admin && !this.employee){
      this.$router.push(`/notFound`);
    } else {
      let rule = this.admin || this.employee;
      Vue.prototype.$globalCurrencyCode = rule.project.currencyCode || "THB";
      Vue.prototype.$globalVatPercent = parseFloat(rule.project.vatPercent || process.env.VUE_APP_VAT_PERCENT || 7)
      Vue.prototype.$globalLocale = rule.project.locale || "th";
      Vue.prototype.$globalCurrencySupports = [Vue.prototype.$globalCurrencyCode];
      if (rule.project.currencySupports?.length) {
        Vue.prototype.$globalCurrencySupports = rule.project.currencySupports;
        this.$store.dispatch("currencyRate/getLastCurrencyRate");
      }
      this.$store.commit("markets/setMarket", { market: { market: rule.market } });
      this.$store.commit("markets/setProjectId", { projectId: rule.project.objectId });
    }
    this.$store.dispatch("appeal/checkWaitingStatus", this.marketId);
  }
}
</script>

<style>

</style>